module.exports = __webpack_public_path__ + "static/media/14UNEP9.b354e4f2.jpg";